/**
 * Signals PDF Service that page is rendered and ready to be processed.
 */
export function signalPdfReady() {
    setTimeout(() => console.log('pdf.render'), 1000);
}
